import { useTranslation } from "react-i18next";
import TabsComponent from "../../../../components/tabs/TabsComponent";
import { ReceivedTab } from "./ReceivedTab";
import { OutGoingTab } from "./OutGoingTab";
import { showChangeScheduleRequests } from "../../../../api/endpoints/students/requests";
import { makeApiRequest, showApiErrorMessages } from "../../../../helpers";
import RequestsModel from "../../../../api/models/RequestsModel";
import { ApiResponse } from "../../../../api/apiResponse";
import { useEffect, useState } from "react";

export default function AppointmentsStudentRequests() {
  const LocalBasePath = "page.tutor.dashboard.requests";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const [requestsReceived, setRequestsReceived] = useState<RequestsModel[]>([]);
  const [oldRequests, setOldRequests] = useState<RequestsModel[]>([]);
  const [requests, setRequests] = useState<RequestsModel[]>([]);

  const showRequests = async () => {
    await makeApiRequest(
      () =>
        showChangeScheduleRequests({
          filters: { sender_type: "Student", order_by: "-created_at" },
        }),
      (response: ApiResponse) => {
        if (response.isSuccess) {
          const { data } = response;
          const requestsList: RequestsModel[] = RequestsModel.fromApiResponse(
            data?.result,
            "sender"
          );
          setRequests(requestsList);
        } else {
          showApiErrorMessages(response);
        }
      }
    );
  };
  const showReceivedRequests = async () => {
    await makeApiRequest(
      () =>
        showChangeScheduleRequests({
          filters: { sender_type: "Tutor", order_by: "-created_at" },
        }),
      (response: ApiResponse) => {
        if (response.isSuccess) {
          const { data } = response;
          const requestsList: RequestsModel[] = RequestsModel.fromApiResponse(
            data?.result,
            "receiver"
          );
          const oldRequestsList: RequestsModel[] =
            RequestsModel.fromApiResponseWithoutPending(
              data?.result,
              "receiver"
            );

          setOldRequests(oldRequestsList);
          setRequestsReceived(requestsList);
        } else {
          showApiErrorMessages(response);
        }
      }
    );
  };
  useEffect(() => {
    showRequests();
    showReceivedRequests();
  }, []);
  const tabs = [
    {
      name: t("received"),
      content: (
        <ReceivedTab oldRequests={oldRequests} requests={requestsReceived} />
      ),
      counter: requestsReceived.length,
    },
    {
      name: t("outgoing"),
      content: <OutGoingTab requests={requests} />,
      counter: requests.length,
    },
  ];
  return (
    <div className="flex flex-col w-full bg-gray-50 ">
      <div>
        <h1 className="px-8 mt-2 mb-4 text-2xl font-semibold text-gray-900 ">
          {t("changeAppointments")}
        </h1>
      </div>
      <TabsComponent requests={true} tabs={tabs} />
    </div>
  );
}
